import React, { useState } from 'react';
import {
  TopToolbar,
  FilterButton,
  Button,
} from 'react-admin';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import UploadMarkdownsDialog from './UploadMarkdownsDialog';

const ItemAdjustedPricesActions = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  return (
    <TopToolbar sx={{ flex: 'none' }}>
      <FilterButton />
      <Button
        label="Upload markdowns"
        onClick={() => setIsUploadOpen(true)}
        startIcon={<FileUploadIcon />}
      />
      <UploadMarkdownsDialog
        open={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
      />
    </TopToolbar>
  );
};

export default ItemAdjustedPricesActions;
